<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-lg.font-semibold.mb-2 Are you sure you want to undo completion for this document?
      .text-md.mb-2 Click “Undo completion” to undo this document completion. Your document status will be changed to “Active”.
    v-divider
    v-card-actions.px-6
      v-spacer
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-btn.button-md(:loading="loading" depressed dark @click="handleConfirm") Undo completion
</template>
  
<script>
export default {
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    handleConfirm () {
      this.$emit('confirmed')
    },
  },
}
</script>

<style scoped>
</style>